import { i18n } from '@/plugins/i18n';

const JOBPOSTING_ASSIGNMENT_STATUS_INITIATED = "00";
const JOBPOSTING_ASSIGNMENT_STATUS_APPLIED = "10";
const JOBPOSTING_ASSIGNMENT_STATUS_SCREENING = "20";
const JOBPOSTING_ASSIGNMENT_STATUS_SHORTLISTED = '24';
const JOBPOSTING_ASSIGNMENT_STATUS_CANDIDATE_SUBMITTED = '25';
const JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW = "30";
const JOBPOSTING_ASSIGNMENT_STATUS_REVIEW = "35";
const JOBPOSTING_ASSIGNMENT_STATUS_ABANDONED = "40";
const JOBPOSTING_ASSIGNMENT_STATUS_REJECTED = "45";
const JOBPOSTING_ASSIGNMENT_STATUS_OFFERED = "50";
const JOBPOSTING_ASSIGNMENT_STATUS_OFFER_EXTENDED = "60";
const JOBPOSTING_ASSIGNMENT_STATUS_ACCEPTED = "70";
const JOBPOSTING_ASSIGNMENT_STATUS_OFFER_WITHDRAW = "75";
const JOBPOSTING_ASSIGNMENT_STATUS_REFUSED = "80";
const JOBPOSTING_ASSIGNMENT_STATUS_REVOKED = "85";
const JOBPOSTING_ASSIGNMENT_STATUS_HIRED = "90";
const JOBPOSTING_ASSIGNMENT_STATUS_TERMINATED = "95";
const JOBPOSTING_ASSIGNMENT_STATUS_STANDBY = "100";
const MYJOBS_REJECTED_MESSAGE = "Job Rejected";
const MYJOBS_ACCEPTED_MESSAGE = "Job Accepted Successfully"
const JOB_PAY_UOM_HOUR = "01";
const JOB_PAY_UOM_TIMESLOT = "02";
const JOB_PAY_UOM_YEAR = "03";
const JOB_PAY_UOM_WEEK = "04";
const JOB_PAY_UOM_DAY = "05";
const JOB_PAY_UOM_MONTH = "06";


const JOB_EMPLOYMENT_TYPE_DIRECT_HIRE = "Direct Hire";
const JOB_EMPLOYMENT_TYPE_CONTRACT = "Contract";
const JOB_EMPLOYMENT_TYPE_CONTRACT_TO_HIRE = "Contract to Hire";
const JOB_EMPLOYMENT_TYPE_SEASONAL = "Seasonal";
const JOB_EMPLOYMENT_TYPE_FLEX = "Flex";

const JOB_DEFAULT_VALID_DAYS = 30;

// Job Posting Type
const JOB_POSTING_TYPE_FULL_TIME = "01";
const JOB_POSTING_TYPE_FLEX = "02";
const JOB_POSTING_TYPE_SEASONAL = "03";
const JOB_EMPLOYMENT_TYPES_JSONLD_MAPPING_DEFAULT = 'OTHER';

const APPLIED_STATUS_ALERT = 'jobconstants.application.received';
const SCREENING_STATUS_ALERT = 'jobconstants.screening';
const SHORTLISTED_STATUS_ALERT = 'jobconstants.shortlisted';
const CANDIDATE_SUBMITTED_STATUS_ALERT = 'jobconstants.candidate.submitted';
const INTERVIEW_STATUS_ALERT = 'jobconstants.interview';
const REVIEW_STATUS_ALERT = 'jobconstants.review';

const APPLICATION_STATUS = {
  [JOBPOSTING_ASSIGNMENT_STATUS_APPLIED]: i18n.t('jobconstants.application.applied'),
  [JOBPOSTING_ASSIGNMENT_STATUS_SCREENING]: i18n.t('jobconstants.application.screening'),
  [JOBPOSTING_ASSIGNMENT_STATUS_SHORTLISTED]: i18n.t('jobconstants.application.shortlisted'),
  [JOBPOSTING_ASSIGNMENT_STATUS_CANDIDATE_SUBMITTED]: i18n.t('jobconstants.application.candidate.submitted'),
  [JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW]: i18n.t('jobconstants.application.interview'),
  [JOBPOSTING_ASSIGNMENT_STATUS_REVIEW]: i18n.t('jobconstants.application.review')
};

const APPLICATION_ALERT_STATUS_TEXT = {
  [JOBPOSTING_ASSIGNMENT_STATUS_APPLIED]: APPLIED_STATUS_ALERT,
  [JOBPOSTING_ASSIGNMENT_STATUS_SCREENING]: SCREENING_STATUS_ALERT,
  [JOBPOSTING_ASSIGNMENT_STATUS_SHORTLISTED]: SHORTLISTED_STATUS_ALERT,
  [JOBPOSTING_ASSIGNMENT_STATUS_CANDIDATE_SUBMITTED]: CANDIDATE_SUBMITTED_STATUS_ALERT,
  [JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW]: INTERVIEW_STATUS_ALERT,
  [JOBPOSTING_ASSIGNMENT_STATUS_REVIEW]: REVIEW_STATUS_ALERT
};

// Employment type mapping (Need to sync with the server and new values for job type (01, 02, 03, 04, 05))
export const JOB_EMPLOYMENT_TYPES_JSONLD_MAPPING = [
  { jobPostingType: JOB_POSTING_TYPE_FULL_TIME, candidatePlacementTypeValue: '01', jsonldCode: 'FULL_TIME' }, //Direct Hire
  { jobPostingType: JOB_POSTING_TYPE_FULL_TIME, candidatePlacementTypeValue: '02', jsonldCode: 'CONTRACTOR' }, // Contrac
  { jobPostingType: JOB_POSTING_TYPE_FULL_TIME, candidatePlacementTypeValue: '03', jsonldCode: 'CONTRACTOR' }, // Contract to Hire
  { jobPostingType: JOB_POSTING_TYPE_FULL_TIME, candidatePlacementTypeValue: '30', jsonldCode: 'FULL_TIME' }, // 24/7? / Permanent?
  { jobPostingType: JOB_POSTING_TYPE_FLEX, candidatePlacementTypeValue: '00', jsonldCode: 'PER_DIEM' }, // Full Time Contract Job (Flex)
  { jobPostingType: JOB_POSTING_TYPE_FLEX, candidatePlacementTypeValue: null, jsonldCode: 'PER_DIEM' }, // Part Time Contract Job (Flex)
  { jobPostingType: JOB_POSTING_TYPE_SEASONAL, candidatePlacementTypeValue: '00', jsonldCode: 'TEMPORARY' }, // Full Time Contract Job (Seasonal)
  { jobPostingType: JOB_POSTING_TYPE_SEASONAL, candidatePlacementTypeValue: null, jsonldCode: 'TEMPORARY' }, // Part Time Contract Job (Seasonal)
  { jsonldCode: JOB_EMPLOYMENT_TYPES_JSONLD_MAPPING_DEFAULT, default: true }, // Other
];


// Unit of measurement for payment
export const JOB_PAY_UOMS_MAPPING = [
    { code: JOB_PAY_UOM_HOUR, text: "HOUR" },
    { code: JOB_PAY_UOM_TIMESLOT, text: "DAY" },
    { code: JOB_PAY_UOM_YEAR, text: "YEAR" },
    { code: JOB_PAY_UOM_WEEK, text: "WEEK" },
    { code: JOB_PAY_UOM_DAY, text: "DAY" },
    { code: JOB_PAY_UOM_MONTH, text: "MONTH" },
    { code: null, text: "" },
];

export {
    JOBPOSTING_ASSIGNMENT_STATUS_APPLIED,
    JOBPOSTING_ASSIGNMENT_STATUS_SCREENING,
    JOBPOSTING_ASSIGNMENT_STATUS_SHORTLISTED,
    JOBPOSTING_ASSIGNMENT_STATUS_CANDIDATE_SUBMITTED,
    JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW,
    JOBPOSTING_ASSIGNMENT_STATUS_REVIEW,
    JOBPOSTING_ASSIGNMENT_STATUS_ABANDONED,
    JOBPOSTING_ASSIGNMENT_STATUS_REJECTED,
    JOBPOSTING_ASSIGNMENT_STATUS_OFFERED,
    JOBPOSTING_ASSIGNMENT_STATUS_OFFER_EXTENDED,
    JOBPOSTING_ASSIGNMENT_STATUS_ACCEPTED,
    JOBPOSTING_ASSIGNMENT_STATUS_OFFER_WITHDRAW,
    JOBPOSTING_ASSIGNMENT_STATUS_REFUSED,
    JOBPOSTING_ASSIGNMENT_STATUS_REVOKED,
    JOBPOSTING_ASSIGNMENT_STATUS_HIRED,
    JOBPOSTING_ASSIGNMENT_STATUS_TERMINATED,
    JOBPOSTING_ASSIGNMENT_STATUS_STANDBY,
    MYJOBS_ACCEPTED_MESSAGE,
    MYJOBS_REJECTED_MESSAGE,
    JOB_PAY_UOM_HOUR,
    JOB_PAY_UOM_TIMESLOT,
    JOB_PAY_UOM_YEAR,
    JOB_PAY_UOM_WEEK,
    JOB_PAY_UOM_DAY,
    JOB_PAY_UOM_MONTH,
    JOB_DEFAULT_VALID_DAYS,
    JOB_EMPLOYMENT_TYPES_JSONLD_MAPPING_DEFAULT,
    APPLIED_STATUS_ALERT,
    SCREENING_STATUS_ALERT,
    SHORTLISTED_STATUS_ALERT,
    CANDIDATE_SUBMITTED_STATUS_ALERT,
    INTERVIEW_STATUS_ALERT,
    REVIEW_STATUS_ALERT,
    APPLICATION_STATUS,
    APPLICATION_ALERT_STATUS_TEXT
};
